import { TYPES } from "./default_bailiff.type";
import { onSnapshot, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/bailiff/api";

// ========= firebase function =========//
//snap all provider
const allDefaultBailiffSub = [];
export const snapDefaultBailiff =
  ({ clientId }, callback) =>
  (dispatch) => {
    setDefaultBailiffAllSuccess(dispatch, null);
    const cRef = getRefs().bailiff;
    const c0 = where("client", "==", clientId);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        setDefaultBailiffAllSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    allDefaultBailiffSub.push(unsub);
  };

export const unSnapDefaultBailiff = () => (dispatch) => {
  allDefaultBailiffSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultBailiffSub.length = 0;
};

// snap detail.
const allDefaultBailiffDetailSub = [];
export const snapDefaultBailiffDetail =
  ({ clientId, bailiffId }, callback) =>
  (dispatch) => {
    setDefaultBailiffDetailSuccess(dispatch, null);
    const cRef = getRefs().bailiff;
    const c0 = where("id", "==", bailiffId);
    const c1 = where("client", "==", clientId);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        const detail = data?.length > 0 ? data[0] : null;
        console.log({ data });
        setDefaultBailiffDetailSuccess(dispatch, detail);
        if (callback) {
          callback();
        }
      }
    });
    allDefaultBailiffDetailSub.push(unsub);
  };

export const unSnapDefaultBailiffDetail = () => (dispatch) => {
  allDefaultBailiffDetailSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultBailiffDetailSub.length = 0;
};

// ========= cloud function =========//
// :::: forward đoạn văn :::::://
export const forwardClient =
  ({ id, numberOfPage }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().reseller.forwardClient;
    const options = { id, numberOfPage };
    console.log({ options });
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };
// ========= local function =========//
export const setDefaultBailiffAll = (data, callback) => (dispatch) => {
  setDefaultBailiffAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBailiffOpenAdd = (data, callback) => (dispatch) => {
  setDefaultBailiffOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBailiffOpenEdit = (data, callback) => (dispatch) => {
  setDefaultBailiffOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBailiffSelected = (data, callback) => (dispatch) => {
  setDefaultBailiffSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBailiffSearch = (data, callback) => (dispatch) => {
  setDefaultBailiffSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultBailiffAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_ALL,
    payload: data,
  });
};

const setDefaultBailiffOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_OPEN_ADD,
    payload: data,
  });
};

const setDefaultBailiffOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultBailiffSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_SELECTED,
    payload: data,
  });
};

const setDefaultBailiffSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_SEARCH,
    payload: data,
  });
};

const setDefaultBailiffDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BAILIFF_DETAIL,
    payload: data,
  });
};
